import {
  applyContextOptions,
  restoreContextOptions,
} from "@tradingApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@tradingApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@tradingApp/helpers/canvas/types";
import { isObject } from "@tradingApp/utils/object";

interface DrawCircleOptions extends BasicDrawOptions {
  x: number;
  y: number;
  radius: number;
  startAngle?: number;
  degrees?: number;
}

export function drawCircle(options: DrawCircleOptions): void {
  const {
    context,
    x,
    y,
    radius,
    startAngle = 0,
    degrees = 360,
    contextOptions,
  } = options;

  const radianInDegree = Math.PI / 180;
  applyTranslate(options);
  applyContextOptions(options);
  context.save();
  context.beginPath();
  context.arc(x, y, radius, startAngle, radianInDegree * degrees);

  if (isObject(contextOptions)) {
    if (contextOptions.fillStyle) {
      context.fill();
    }

    if (contextOptions.lineWidth || contextOptions.strokeStyle) {
      context.stroke();
    }
  }

  context.restore();
  restoreContextOptions(options);
  restoreTranslate(options);
}
